import { FulfillmentQueueName } from 'hooks/useFulfillmentQueue'

export const isOrderLevelQueue = (queueName?: FulfillmentQueueName): boolean =>
  queueName === FulfillmentQueueName.Packing ||
  queueName === FulfillmentQueueName.Triage ||
  queueName === FulfillmentQueueName.PV1 ||
  queueName === FulfillmentQueueName.PV2

// Get active queue from route. Use only when `useFulfillmentQueue`
// is not available in upper level components
export const getQueueNameFromPath = (pathname: string): string | undefined =>
  pathname.match(/^\/fulfillment\/([^/]+)/)?.[1]
